import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from './../../shared/shared.module'
import { OpcodeServiceManagementRoutingModule } from './opcode-service-management-routing.module';
import { OpcodeServiceManagementComponent } from './opcode-service-management.component';
import { OpcodeServiceListComponent } from './opcode-service-list/opcode-service-list.component';
import { OpcodeServiceFormComponent } from './opcode-service-form/opcode-service-form.component';
import { OtherServiceOpcodeComponent } from './other-service-opcode/other-service-opcode.component';
import { CreateOpcodeFormComponent } from './create-opcode-form/create-opcode-form.component';
import { OpcodeItemComponent } from './opcode-item/opcode-item.component';


@NgModule({
  declarations: [OpcodeServiceManagementComponent, OpcodeServiceListComponent, OpcodeServiceFormComponent,OtherServiceOpcodeComponent, CreateOpcodeFormComponent, OpcodeItemComponent],
  imports: [
    CommonModule,
    SharedModule,
    OpcodeServiceManagementRoutingModule
  ]
})
export class OpcodeServiceManagementModule { }
